var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.availablePaymentMethodItems, function (paymentMethod) {
      return _c(
        "payment-tile",
        _vm._b(
          {
            key: paymentMethod.type,
            attrs: { "data-qa": paymentMethod.dataQa },
            on: { selected: _vm.onPaymentSelected },
          },
          "payment-tile",
          paymentMethod,
          false
        ),
        [
          paymentMethod.component
            ? _c(paymentMethod.component, {
                ref: "paymentMethodForm",
                refInFor: true,
                tag: "component",
                attrs: {
                  "is-save-card-checkbox-visible": true,
                  "enabled-card-networks": _vm.enabledCardNetworks,
                },
                on: { "form-details-changed": _vm.onPaymentMethodFormChange },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }